import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import envConfig from '@nile/home/src/Config/env';
import { COMMON_CONSTANTS, Loader } from '@nile/components';
import {
  AccountClient,
  GET_INTEGRATIONS_BY_IDS,
  useQuery
} from '@nile/graphql';
import { isEmpty } from 'lodash';
import { useGlobalState } from '@nile/components/src/Managers/StateManager';

// This HOC wraps the component with Elements from stripe and provides the context data
const withStripeElements = (Component, options) => {
  return function WithStripeElements(props) {
    const [stripeAccountId, setStripeAccountId] = useGlobalState(
      'stripeAccountId',
      null,
      true
    );
    const [isLoading, setIsLoading] = useState(true); // Track loading state

    const { loading, data, refetch } = useQuery(GET_INTEGRATIONS_BY_IDS, {
      fetchPolicy: COMMON_CONSTANTS.CACHE_POLICIES.NO_CACHE,
      client: AccountClient,
      variables: {
        integrationIds: ['STRIPE']
      },
      skip: !isEmpty(stripeAccountId),
      onCompleted(res) {
        const integrationIds = res?.getIntegrationsByIds;
        if (integrationIds?.length) {
          const stripeData = integrationIds.find(
            (integration) => integration.activated
          );
          if (
            stripeData?.data?.accountId &&
            stripeData?.connectionStatus === 'CONNECTED'
          ) {
            setStripeAccountId(stripeData?.data?.accountId);
          }
        }
      }
    });

    const loadStripeInstance = stripeAccountId
      ? loadStripe(envConfig.stripePublicKey, {
          stripeAccount: stripeAccountId // If there is stripeAccountId we'll return this loadStripe
        })
      : null;

    useEffect(() => {
      if (stripeAccountId) {
        setIsLoading(false);
      }
    }, [stripeAccountId]);

    return (
      <>
        {loadStripeInstance && stripeAccountId && !isLoading ? (
          <Elements stripe={loadStripeInstance} options={options}>
            {/* stripe accepts a function that return loadStripe Promise*/}
            <Component {...props} />
          </Elements>
        ) : (
          <></>
        )}
      </>
    );
  };
};

export default withStripeElements;
